import { defineMessages } from 'react-intl';

type MessageKeys = 'placeholder' | 'placeholderShort';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		placeholder: {
			id: 'ai-mate.chat-input.placeholder',
			defaultMessage: 'Write a prompt to get started',
			description: 'Placeholder for the chat input',
		},
		placeholderShort: {
			id: 'ai-mate.chat-input.placeholder.short',
			defaultMessage: 'Write a prompt...',
			description:
				'Shortened placeholder for the chat input in chromeless/inline comment contexts where space is limited.',
		},
	});

export default message;
